import type { ComponentProps } from 'react'
import IMG_LOGO from 'src/assets/logo.svg'
import { cn } from 'src/utils/cx'

export default function Logo({
  className,
  ...attrs
}: Omit<ComponentProps<'img'>, 'src'>) {
  return (
    <img
      alt="PixAI Logo"
      {...attrs}
      className={cn('dark:invert', className)}
      src={IMG_LOGO}
    />
  )
}

export function Mio2Logo(props: React.HTMLAttributes<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden="true"
      width="100%"
      height="100%"
      viewBox="0 -20 400 400"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
      }}
    >
      <g>
        <path
          fill="#85ceff"
          d="M188.6,190.1c17,2.8,25.3-12.9,9.8-22.3-17.9-9.2-40.9-19.4-47.5-39.6-3.7-12.7-2.6-30,1.4-43.4,15.4-58.7,71.8-80.3,125.8-61.6,37.3,12.3,71.3,42.4,80.6,82,2.4,9.9,3.3,21.9,2.5,32.5-.8,16.8-10.6,28.3-25.6,35.3-4.4,2.2-9.2,4.1-13.7,5.9-3.8,1.5-7.7,3-10.6,5.8-4.6,4.1-5.5,12.2-.4,16.3,4.2,3.6,11.4,3.4,16.9,1.9,42.7-13.3,54.7-68.5,44.2-107.8-9.9-39.9-43.4-71.6-79.4-84.9C236.3-11.8,167.7.3,143.5,61.6c-14.9,35.5-13.5,80.9,13.4,110.2,8.7,9.2,19.1,16.5,31.4,18.5h.2v-.2h.1Z"
        />
        <path
          fill="#c3e4ff"
          d="M266,144.4c21,0,28.7-20.5,20-37.8-1.8-3.6-4.4-6.7-7.4-9.4-14.2-12.8-41.7-9-43.7,12.8-2.6,19.4,11.6,34.8,30.9,34.4h.2ZM249.2,113c3.3-10.6,17.9-6.5,23.2,1,5.1,6.2,1.8,13.8-6.3,14-7.7.4-18.2-6.4-16.9-14.8v-.2h0Z"
        />
        <path
          fill="currentColor"
          d="M130.9,314.8c-2-4.9-8.1-5.8-12.8-5.8-6.8,0-13.8.8-20.5-.5-4.8-.7-10.4-2.7-15-.5-6.2,3.1-4.3,12.1,1,15.4,8.8,5.3,19.6,3.9,29.5,3.8,7.2,0,20.5-2.3,17.8-12.2h0v-.2h0Z"
        />
        <path
          fill="currentColor"
          d="M196.3,307.7c-1.8-10.3-13.2-14.7-21.7-9.4-10.6,7.4-7.1,27.6,5.5,30.3,11.7,2.6,18.7-10.5,16.3-20.7v-.2h0Z"
        />
        <path
          fill="currentColor"
          d="M309.6,348.7c-.6-4.8-4.4-9.8-7.4-13.8-27-35.4-34.9-87.4-38.3-133.2-.5-7.7-.8-15.4-1.1-23-.3-6.2-.6-15.5-5.9-18.7-6.5-3.5-13.4,4.4-17.2,9.8-20,32.4-54.1,83.4-84.1,87.1-22.5,3.2-32.5-28.1-36-47.2-2-9.1-2.1-19.5-5.9-28.3-4.1-9.1-12.9-8.4-19.1-1-3.9,4.3-6.6,9.8-9,14.9-19,44.9-53.1,97.6-77.6,134.8-4.4,6.7-11.4,17.3-6,24.9,3.7,4.7,12,4.4,17,.9,7.1-4.8,8.8-13.9,12.4-21.5,1.7-3.8,3.6-7.5,5.5-11.2,18.9-34.6,37-71,55.1-105.7,2-3.2,4-8.2,7.7-9,2.6-.5,4.6,6.8,5.4,10.1,10.3,55.1,44.7,75.9,90.2,38,15.5-12.6,27.5-28.2,38.8-44.6,9.3-12.4,7.6,6.9,7.7,13.1-.3,35.7,5.1,72.6,24.6,102.7,2.2,3.5,4.4,6.9,6.5,10.4,4.3,6.8,7.1,14.6,13.9,18.7,7.2,4.6,23.7,3.1,22.8-8.1v-.2h0Z"
        />
      </g>
    </svg>
  )
}
